// PDF counterpart of FileTypeIcon (which is CSV-specific). Same document outline
// and badge; only the badge label differs.
const PdfFileIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z"
        stroke="#D0D5DD"
        strokeWidth="1.5"
      />
      <path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" strokeWidth="1.5" />
      <path
        d="M0 20C0 18.8954 0.895431 18 2 18H26C27.1046 18 28 18.8954 28 20V32C28 33.1046 27.1046 34 26 34H2C0.895431 34 0 33.1046 0 32V20Z"
        fill="#15803D"
      />
      <text
        x="14"
        y="30"
        textAnchor="middle"
        fill="white"
        fontFamily="Inter, sans-serif"
        fontSize="10"
        fontWeight="700"
      >
        PDF
      </text>
    </svg>
  );
};

export default PdfFileIcon;
